// @flow

import styled from "@emotion/styled";

export const SaveChanges = styled.div`
  display: inline-grid;
  gap: 1em;
  grid-auto-flow: column;
`;
